import { render, staticRenderFns } from "./searchTalent.vue?vue&type=template&id=39b67d5c&scoped=true"
import script from "./searchTalent.vue?vue&type=script&lang=js"
export * from "./searchTalent.vue?vue&type=script&lang=js"
import style0 from "./searchTalent.vue?vue&type=style&index=0&id=39b67d5c&prod&lang=less&scoped=true"
import style1 from "./searchTalent.vue?vue&type=style&index=1&id=39b67d5c&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39b67d5c",
  null
  
)

export default component.exports